export default __webpack_public_path__ + "static/media/card-items.4fa9073f.svg";